import React from 'react'
import {MultiFilePicker} from '../../../../components/MutliFilePicker'
import {KTSVG} from '../../../../_metronic/helpers'
import IconDownload from '../../../../components/icon/IconDownload'
import {toast} from 'react-toastify'
import {downloadPjSuppl} from '../../../../components/requests'

type Props = {
  images: any | undefined
  setImages: any | undefined // Pj demande
  isTraitementDemande?: boolean | undefined
}

const DemandePj = ({images, setImages, isTraitementDemande = false}: Props) => {
  const nameOfImage = images.map((item) => item.file.name) ?? []

  // Lit le message d'erreur renvoyé par le serveur (la réponse d'erreur est aussi un ArrayBuffer)
  const parseErrorMessage = (error: any): string | null => {
    try {
      const data = error?.response?.data
      if (data instanceof ArrayBuffer) {
        const text = new TextDecoder('utf-8').decode(data)
        return JSON.parse(text)?.message ?? null
      }
      return data?.message ?? null
    } catch {
      return null
    }
  }

  // Déclenche le téléchargement d'une réponse axios (arraybuffer)
  const saveBlob = (response: any, fallbackName: string, fallbackType: string) => {
    const contentType = response.headers['content-type'] || fallbackType
    const blob = new Blob([response.data], {type: contentType})

    // Nom envoyé par le serveur (Content-Disposition), sinon nom de secours sans chemin
    const disposition = response.headers['content-disposition'] || ''
    const match = disposition.match(/filename\*?=(?:UTF-8'')?"?([^";]+)"?/i)
    const fileName = match
      ? decodeURIComponent(match[1])
      : String(fallbackName).split('/').pop() || 'document'

    const fileURL = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = fileURL
    link.download = fileName
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    window.URL.revokeObjectURL(fileURL)
  }

  const handleDownloadPJ = async () => {
    const idToast = toast.loading('Téléchargement en cours...')

    try {
      //demande PJ (fichier unique ou zip) => uniquement dans l'historique devis
      if (nameOfImage?.length > 0) {
        // petit délai : certains navigateurs bloquent 2 téléchargements simultanés
        await new Promise((resolve) => setTimeout(resolve, 500))

        const pjResponse = await downloadPjSuppl(nameOfImage, true)

        // Un seul fichier : on connaît son nom, sinon zip
        const fallbackName = nameOfImage.length === 1 ? nameOfImage[0] : 'pieces-jointes.zip'

        saveBlob(pjResponse, fallbackName, 'application/octet-stream')
      }

      toast.update(idToast, {
        render: 'Téléchargement effectué avec succès',
        type: 'success',
        isLoading: false,
        autoClose: 3000,
      })
    } catch (error) {
      const errorMsg =
        parseErrorMessage(error) || 'Erreur lors du téléchargement des pièces jointes'

      console.error(errorMsg, error)
      toast.update(idToast, {
        render: errorMsg,
        type: 'error',
        isLoading: false,
        autoClose: 3000,
      })
    } finally {
      console.log('finally')
    }
  }

  return (
    <div className='row mt-5'>
      <div className='mb-5'>
        <div className='d-flex'>
          <div className='d-flex gap-2 order-first me-auto'>
            <KTSVG path='/media/svg/files/pj.svg' className='svg-icon svg-icon-2x' />
            <h2>Pièces jointes</h2>
          </div>
          {isTraitementDemande && (
            <div>
              <button
                type='button'
                className='btn btn-sm btn-primary'
                onClick={() => handleDownloadPJ()}
              >
                <IconDownload />
                <span className='mx-2'>Télécharger</span>
              </button>
            </div>
          )}
        </div>
        <span className='mb-2'>
          {isTraitementDemande
            ? 'Pièce jointe de la demande : '
            : 'Ajoutez des pièces jointes à la demande (images de tous formats ou documents PDF) : '}
        </span>
      </div>
      <MultiFilePicker
        images={images}
        setImages={setImages}
        isDemandePj={true}
        isTraitementDemande={isTraitementDemande}
      />
    </div>
  )
}

export default DemandePj
